var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-modal",
    {
      model: {
        value: _vm.isVisible,
        callback: function($$v) {
          _vm.isVisible = $$v
        },
        expression: "isVisible"
      }
    },
    [
      _c("h2", {
        staticClass: "text-center",
        domProps: { innerHTML: _vm._s(_vm.$t("grantAccessClinicHistory")) }
      }),
      _vm._v(" "),
      _c("p", {
        domProps: { innerHTML: _vm._s(_vm.$t("historyGrantAccessText")) }
      }),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass: "text-center px-2 my-2",
                  attrs: { sm: "12", md: "6" }
                },
                [
                  _c("base-button", { on: { click: _vm.shareInternally } }, [
                    _vm._v(_vm._s(_vm.$t("shareInternally")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "text-center px-2 my-2",
                  attrs: { sm: "12", md: "6" }
                },
                [
                  _c(
                    "base-button",
                    { attrs: { white: "" }, on: { click: _vm.generateLink } },
                    [_vm._v(_vm._s(_vm.$t("generateLink")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showInternalShareSelector
        ? _c(
            "b-row",
            { staticClass: "mt-4" },
            [
              _c(
                "b-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c("base-select", {
                    attrs: {
                      loading: _vm.selectProfCenter.loading,
                      placeholder: _vm.$t("clinic-history.select-prof-center"),
                      label: "name",
                      valueProp: "id",
                      searchable: "",
                      filtered: "",
                      options: _vm.selectProfCenter.data,
                      clearable: ""
                    },
                    on: {
                      search: function($event) {
                        return _vm.loadProfsAndCenters($event)
                      }
                    },
                    model: {
                      value: _vm.selectProfCenter.value,
                      callback: function($$v) {
                        _vm.$set(_vm.selectProfCenter, "value", $$v)
                      },
                      expression: "selectProfCenter.value"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      staticClass: "mt-4 grant-access-btn",
                      on: { click: _vm.grantInternalAccessHistory }
                    },
                    [_vm._v(_vm._s(_vm.$t("historyShare")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showGenerateLinkSelector
        ? _c("div", { staticClass: "mt-4" }, [
            _c(
              "div",
              [
                _c("h3", {
                  domProps: { innerHTML: _vm._s(_vm.$t("validityInDays")) }
                }),
                _vm._v(" "),
                _c("base-input", {
                  attrs: {
                    type: "number",
                    placeholder: _vm.$t("shareLinkValidity"),
                    min: 1,
                    max: 180
                  },
                  model: {
                    value: _vm.shareLink.validity,
                    callback: function($$v) {
                      _vm.$set(_vm.shareLink, "validity", $$v)
                    },
                    expression: "shareLink.validity"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("h3", {
                  domProps: { innerHTML: _vm._s(_vm.$t("recipients")) }
                }),
                _vm._v(" "),
                _c("base-textarea", {
                  attrs: {
                    rows: 5,
                    placeholder: _vm.$t("shareHistoryAccessLinkPlaceholder")
                  },
                  model: {
                    value: _vm.shareLink.emails,
                    callback: function($$v) {
                      _vm.$set(_vm.shareLink, "emails", $$v)
                    },
                    expression: "shareLink.emails"
                  }
                }),
                _vm._v(" "),
                _c(
                  "base-button",
                  {
                    staticClass: "mt-4 grant-access-btn",
                    on: { click: _vm.sendLink }
                  },
                  [_vm._v(_vm._s(_vm.$t("send")))]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76349f96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76349f96","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/HistoryGrantAccess.vue
// module id = 1691
// module chunks = 116